import { renovation_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateRenovationTypeEnum = (enumValue: renovation_type_enum) => {
  switch (enumValue) {
    case renovation_type_enum.CREATE_VENTILATION:
      return <Trans i18nKey="Enum_RenovationTypeEnum-CREATE_VENTILATION" />;
    case renovation_type_enum.CUSTOM:
      return <Trans i18nKey="Enum_RenovationTypeEnum-CUSTOM" />;
    case renovation_type_enum.ENERGY_CONSUMER:
      return <Trans i18nKey="Enum_RenovationTypeEnum-ENERGY_CONSUMER" />;
    case renovation_type_enum.ENERGY_SYSTEM_ROUTE:
      return <Trans i18nKey="Enum_RenovationTypeEnum-ENERGY_SYSTEM_ROUTE" />;
    case renovation_type_enum.ENVELOPE:
      return <Trans i18nKey="Enum_RenovationTypeEnum-ENVELOPE" />;
    case renovation_type_enum.EXCLUSION_NOTE:
      return <Trans i18nKey="Enum_RenovationTypeEnum-EXCLUSION_NOTE" />;
    case renovation_type_enum.EXISTING_VENTILATION:
      return <Trans i18nKey="Enum_RenovationTypeEnum-EXISTING_VENTILATION" />;
    case renovation_type_enum.HYDRAULIC_BALANCING:
      return <Trans i18nKey="Enum_RenovationTypeEnum-HYDRAULIC_BALANCING" />;
    case renovation_type_enum.MAINTENANCE:
      return <Trans i18nKey="Enum_RenovationTypeEnum-MAINTENANCE" />;
    case renovation_type_enum.SOLAR_PLANT:
      return <Trans i18nKey="Enum_RenovationTypeEnum-SOLAR_PLANT" />;
  }
};

export const translateRenovationTypeEnum_dynamic = (enumValue: renovation_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case renovation_type_enum.CREATE_VENTILATION:
      return t('Enum_RenovationTypeEnum-CREATE_VENTILATION');
    case renovation_type_enum.CUSTOM:
      return t('Enum_RenovationTypeEnum-CUSTOM');
    case renovation_type_enum.ENERGY_CONSUMER:
      return t('Enum_RenovationTypeEnum-ENERGY_CONSUMER');
    case renovation_type_enum.ENERGY_SYSTEM_ROUTE:
      return t('Enum_RenovationTypeEnum-ENERGY_SYSTEM_ROUTE');
    case renovation_type_enum.ENVELOPE:
      return t('Enum_RenovationTypeEnum-ENVELOPE');
    case renovation_type_enum.EXCLUSION_NOTE:
      return t('Enum_RenovationTypeEnum-EXCLUSION_NOTE');
    case renovation_type_enum.EXISTING_VENTILATION:
      return t('Enum_RenovationTypeEnum-EXISTING_VENTILATION');
    case renovation_type_enum.HYDRAULIC_BALANCING:
      return t('Enum_RenovationTypeEnum-HYDRAULIC_BALANCING');
    case renovation_type_enum.MAINTENANCE:
      return t('Enum_RenovationTypeEnum-MAINTENANCE');
    case renovation_type_enum.SOLAR_PLANT:
      return t('Enum_RenovationTypeEnum-SOLAR_PLANT');
  }
};
